import { atom } from 'jotai/vanilla';
export function atomWithCache(read, options) {
    const is = (options === null || options === void 0 ? void 0 : options.areEqual) || Object.is;
    // this cache is common across Provider components
    const cache = [];
    const baseAtom = atom(async (get, { setSelf: writeGetter, ...opts }) => {
        var _a;
        await Promise.resolve();
        const index = cache.findIndex((item) => Array.from(item[2]).every(([a, v]) => is(v, writeGetter(a))));
        if (index >= 0) {
            const item = cache[index];
            if ((_a = options === null || options === void 0 ? void 0 : options.shouldRemove) === null || _a === void 0 ? void 0 : _a.call(options, ...item)) {
                cache.splice(index, 1);
            }
            else {
                item[2].forEach((_, a) => get(a)); // touch atoms
                return item[1];
            }
        }
        const map = new Map();
        const value = await read((a) => {
            const v = get(a);
            map.set(a, v);
            return v;
        }, opts);
        cache.unshift([Date.now(), value, map]);
        if ((options === null || options === void 0 ? void 0 : options.size) && options.size < cache.length) {
            cache.pop();
        }
        return value;
    }, (get, _set, anAtom) => get(anAtom));
    if (process.env.NODE_ENV !== 'production') {
        baseAtom.debugPrivate = true;
    }
    const derivedAtom = atom((get) => get(baseAtom));
    return derivedAtom;
}
